import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { FiltersMobileComponent } from './filters-mobile.component';

@NgModule({
	declarations: [FiltersMobileComponent],
	imports: [SharedModule],
	exports: [FiltersMobileComponent],
})
export class FiltersMobileModule {}
